import { Directive, Input, HostListener, SimpleChanges, Output, EventEmitter } from '@angular/core';

@Directive({
  selector: '[simpleValidator]',
  exportAs: 'simpleValidator'
})
export class SimpleValidatorDirective {

  @HostListener('input', ['$event'])
  onInput(event: Event){
    const value = (event.target as HTMLInputElement).value;
    this.applyValidation(value);
    this.validityChanged.emit(this.valid);
  }

  private _valid: undefined | boolean = undefined;
  
  forceShowLabel = false;

  //Allows the parent to specify when the validation should be triggered
  @Input() triggerValidation: boolean | null = null;

  @Input() validatorFunction: ((myVal: string) => boolean) | null = null;

  @Output() validityChanged = new EventEmitter<boolean>();

  initialFlowStarted = false;
  triggerValidationInit = false; //a way to track if the compnent has received that input for the first time

  applyValidation(value: string | null | undefined){
    if ((value === undefined || value === null || value.length === 0) && !this.initialFlowStarted){
      this.initialFlowStarted = true;
      return;
    }

    const basicValidationPassed = !!value && value.trim().length > 0;
    let additionalValidationPassed = true;

    if (this.validatorFunction !== null){
      additionalValidationPassed = this.validatorFunction(value);
    }

    this._valid = basicValidationPassed && additionalValidationPassed;
  }

  get valid(): boolean {
    if (this._valid === undefined){
      return false;
    }
    return this._valid;
  }

  // Show label when blurred if invalid
  @HostListener('blur')
  onBlur() {
    if (this.validityCheckHasBeenRunAndIsInvalid) {
      this.forceShowLabel = true;
    }
  }

  ngOnChanges(changes: SimpleChanges){
    if(changes['triggerValidation'] && !this.triggerValidationInit){
      this.triggerValidationInit = true;
      return;
    }
    else if(changes['triggerValidation']){
      Promise.resolve().then(() => {
        this.forceShowLabel = true; //Wrapped in a promise to avoid messing with angular's detection cycle
    });
    }
  }

  get isInvalidState(){
    return this._valid === undefined || this._valid === false;
  }

  get validityCheckHasBeenRunAndIsInvalid(){
    return this._valid !== undefined && this._valid === false;
  }

  get showLabel(){
    return (this.forceShowLabel && this.isInvalidState) || (this.triggerValidation && this.validityCheckHasBeenRunAndIsInvalid);
  }
}
